<template>
  <div class="slider" :disabled="disabled"></div>
</template>
<script>
import noUiSlider from "nouislider";

export default {
  name: "base-slider",
  props: {
    value: {
      type: [String, Array, Number],
      description: "slider value",
    },
    disabled: {
      type: Boolean,
      default: false,
      description: "whether the slider is disabled",
    },
    start: {
      type: [Number, Array],
      default: 0,
      description:
        "[noUi Slider start](https://refreshless.com/nouislider/slider-options/#section-start)",
    },
    connect: {
      type: [Boolean, Array],
      default: () => [true, false],
      description:
        "[noUi Slider connect](https://refreshless.com/nouislider/slider-options/#section-connect)",
    },
    range: {
      type: Object,
      default: () => {
        return {
          min: 0,
          max: 100,
        };
      },
      description:
        "[noUi Slider range](https://refreshless.com/nouislider/slider-values/#section-range)",
    },
    options: {
      type: Object,
      default: () => {
        return {};
      },
      description:
        "[noUi Slider options](https://refreshless.com/nouislider/slider-options/)",
    },
  },
  data() {
    return {
      slider: null,
    };
  },
  methods: {
    createSlider() {
      noUiSlider.create(this.$el, {
        start: this.value || this.start,
        connect: Array.isArray(this.value) ? true : this.connect,
        range: this.range,
        ...this.options,
      });
      const slider = this.$el.noUiSlider;
      slider.on("slide", () => {
        let value = slider.get();
        if (value !== this.value) {
          this.$emit("input", value);
        }
      });
    },
  },
  mounted() {
    this.createSlider();
  },
  watch: {
    // Was comparing oldValue/newValue and only calling slider.set() when they were ALREADY
    // equal (a no-op), skipping the real case where they differ - inverted, so an externally
    // driven value change (e.g. typing into a paired input elsewhere) never actually moved the
    // slider. Compares against the slider's OWN current value instead (guards against redundant
    // .set() calls, e.g. right after this same slider's own "slide" event set newValue in the
    // first place), and updates whenever that actually differs.
    value(newValue) {
      const slider = this.$el.noUiSlider;
      const sliderValue = slider.get();

      const isSame = Array.isArray(newValue) && Array.isArray(sliderValue)
        ? newValue.length === sliderValue.length &&
          newValue.every((v, i) => String(v) === String(sliderValue[i]))
        : String(newValue) === String(sliderValue);

      if (!isSame) {
        slider.set(newValue);
      }
    },
  },
};
</script>
<style></style>
